import { useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import {
  fetchGetSellerAgreementDocument,
  fetchPutSellerAgreementDocumentSign,
} from '@iwoca/lapi-client/edge';
import { Button } from '@iwoca/orion';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

import styles from './SignAgreement.module.css';
import { useGetSellerOnboardingRequirements } from '../../../api/lending/lapiHooks';
import { useStateKey } from '../../../hooks/useStateKey.hook';

export const SignAgreement = () => {
  const { stateKey } = useStateKey();
  const { fetchSellerOnboardingRequirements: fetchRequirements } =
    useGetSellerOnboardingRequirements();
  const [documentUrl, setDocumentUrl] = useState<string>();
  const [documentId, setDocumentId] = useState<string>();

  useEffect(() => {
    const fetchSellerDocument = async () => {
      try {
        const { data: sellerAgreement } = await fetchGetSellerAgreementDocument(
          { stateKey: stateKey! },
        );
        const documentId = sellerAgreement!.document_id!.toString();
        const documentUrl = `${window.location.origin}/api/lending/edge/seller_agreement_document/${stateKey}/download/${documentId}/?signed=false&file_format=pdf`;

        setDocumentUrl(documentUrl);
        setDocumentId(documentId);
      } catch {}
    };

    void fetchSellerDocument();
  }, [stateKey]);

  const handleSubmit = async () => {
    if (!documentId) return;

    tracking.ampli.finishedSellerSignup();

    await fetchPutSellerAgreementDocumentSign({
      stateKey: stateKey!,
      documentId,
    });
    void fetchRequirements();
  };

  return (
    <Formik
      initialValues={{ hasSigned: false }}
      onSubmit={handleSubmit}
      validationSchema={validation}
    >
      {({ values }) => (
        <Form className={styles.signAgreement}>
          <div className={styles.agreement}>
            <Field type="checkbox" name="hasSigned" id="hasSigned" />
            <label
              className={styles.text}
              htmlFor="hasSigned"
              aria-labelledby="hasSigned"
            >
              I agree to the{' '}
              <a href={documentUrl} download className={styles.link}>
                Seller Agreement
              </a>
            </label>
          </div>
          <Button
            variant="primary"
            className={styles.button}
            type="submit"
            disabled={!values.hasSigned || !documentId}
          >
            Activate my account
          </Button>
        </Form>
      )}
    </Formik>
  );
};

const validation = Yup.object().shape({
  hasSigned: Yup.boolean().isTrue(),
});
